import {WidgetInstance} from "friendly-challenge";

document.addEventListener('DOMContentLoaded', () => {
    const mounts = document.querySelectorAll('.frc-captcha');

    mounts.forEach(mount => {
        const widget = new WidgetInstance(mount, {
            skipStyleInjection: true
        });
    });
});

